import { useState, useEffect } from "react";

import axios from "axios";
import "./Contact.css";

const Contact = () => {

  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post("/api/contact", form);
      alert("Message sent successfully!");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      alert("Error sending message");
    }
  };
   useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <section className="contact-section">
  <div className="contact-card">

    <h2 className="contact-title">Contact Us</h2>
    <p className="contact-subtitle">
      Have questions about testing, training, or partnerships? Let’s talk.
    </p>

    <div className="contact-container">

      {/* LEFT FORM */}
      <form className="contact-form" onSubmit={handleSubmit}>
        <label>Full Name</label>
        <input
          type="text"
          name="name"
          placeholder="Your name"
          value={form.name}
          onChange={handleChange}
          required
        />

        <label>Email Address</label>
        <input
          type="email"
          name="email"
          placeholder="you@example.com"
          value={form.email}
          onChange={handleChange}
          required
        />

        <label>Subject</label>
        <input
          type="text"
          name="subject"
          placeholder="What is this regarding?"
          value={form.subject}
          onChange={handleChange}
          required
        />

        <label>Message</label>
        <textarea
          name="message"
          placeholder="Tell us more about your inquiry..."
          value={form.message}
          onChange={handleChange}
          required
        ></textarea>

        <button type="submit" className="send-btn">
          Send Message
        </button>
      </form>

      {/* RIGHT INFO BOX */}
      <div className="contact-info">
        <h3>Get in Touch</h3>

        <p><strong>Email:</strong><br />support@forgeyourpeak.in</p>
        <p><strong>Business Inquiries:</strong><br />support@forgeyourpeak.in</p>
        <p><strong>Location:</strong><br />Chennai, India</p>

        <hr />

        <h4>Response Time</h4>
        <p>We typically respond within 24–48 hours on business days.</p>
      </div>

    </div>

  </div>
</section>
  );
};

export default Contact;